export const bio = 
 `I'm a software engineer turned founder with a deep interest in artificial intelligence and natural language.` +
 ` After three years building large-scale systems at Amazon, I left to co-found Glyph, where we're defining and building the next generation of {interfaces} interfaces.`;

export const details = [
  { label: 'Location', value: 'United States' },
  { label: 'Current Focus', value: 'Glyph — AI Startup' },
  { label: 'Interests', value: 'Artificial Intelligence, Deep Learning, Distributed Systems, Language' },
];
